<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    d="M2.7 8.7h4.5V4.2h2.1v6.6H2.7V8.7Zm4.5 6.6H2.7v-2.1h6.6v6.6H7.2v-4.5Zm9.6-6.6V4.2h-2.1v6.6h6.6V8.7h-4.5Zm0 11.1h-2.1v-6.6h6.6v2.1h-4.5v4.5Z"
    clip-rule="evenodd"
  /></svg
>
